import { registerLinkResolver } from "@prismicio/gatsby-source-prismic-graphql";
import { linkResolver } from "./src/utils/link-resolver";
import "fontsource-playfair-display-sc/900-normal.css";
import "typeface-rokkitt";
import "typeface-nunito";
import "./src/styles/global.css";

registerLinkResolver(linkResolver);
